import { observer } from 'mobx-react-lite';
import { EventPanelData } from './state/entity-panel-manager';
import { useOpenEventPanel } from '../../../event-panel/use-open-event-panel';
import { useAllEventNotifications } from '../../../event-notifications/use-event-notifications';
import { agencyTypeIconNames } from '../../../common/helpers/agency-type';
import { AgencyTypeGlobal } from '../../../common/global-attributes';
import React from 'react';
import { EntityItem } from './entity-item';

export const EventItem = observer(function EventItem(props: {
    isHistorical: boolean;
    eventPanel?: EventPanelData;
    cfsText?: string;
    agencyEventNumber?: string;
    eventId?: number;
    agencyTypeGlobalAttrId?: number;
}) {
    const openEventPanel = useOpenEventPanel();
    const eventNotificationsForEvent = useAllEventNotifications(props.eventId ?? -1);
    const icon = props.agencyTypeGlobalAttrId
        ? agencyTypeIconNames[props.agencyTypeGlobalAttrId as AgencyTypeGlobal]
        : 'CADEvent';
    const titleText = props.agencyEventNumber ? props.agencyEventNumber : 'New Event Draft';
    const subtitleText = props.cfsText ?? 'No CFS';

    return (
        <EntityItem
            title={titleText}
            subtitle={subtitleText}
            icon={icon}
            allNotifications={eventNotificationsForEvent}
            isPanelFocused={!!props.eventPanel?.workspacePanel.isFocused}
            entityNumber={props.agencyEventNumber}
            onClick={() => {
                if (props.isHistorical) {
                    openEventPanel({
                        eventId: props.eventId,
                        shouldFocusPanel: true,
                    });
                } else {
                    props.eventPanel?.workspacePanel.notifyActivity();
                    props.eventPanel?.workspacePanel.focus();
                }
            }}
            onClose={props.eventPanel ? () => props.eventPanel?.workspacePanel.close() : undefined}
            isPanelAlerting={props.eventPanel?.workspacePanel.isAlerting}
        />
    );
});
